import VueCookies from 'vue-cookies';
import store from "@/store/index.js";
import { getSession } from './functions';

export const common = async Queries =>
{
    if(Queries.length === 0) return;

    const ValidParams = [
   "utm_tracking","utm_source","utm_medium","utm_medio","utm_campaign","utm_content","utm_term",
   "codigoPromotor","codPromotor",
   "branch",
   "gclid","gbraid","wbraid","gad_source","gad_campaignid",
 ];

    for (const Param of Queries) 
    {
        const ValidParam = ValidParams.find(x => x === Param.key);
        if(!ValidParam) continue;
        
        const {key,value} = Param;
        VueCookies.set(key, value, '2d');
        
        store.commit("Misc/setSource", {key,value});
    }

    const Session = getSession();
    
    const Peticion = await Session.get("promotions/utm_tracking/",{headers:
    {
        key:"API_64c56932c0a305e240c61c728715b11e"
    }});

    const Ahora = new Date();
    var Promociones = Peticion.data.filter(promocion =>
    {
        const Vencida = Date.parse(promocion.expires_at) < Ahora;
        if(promocion.status === "1" && !Vencida)
            return promocion;
    });

    const {utm_tracking,utm_source} = store.state.Misc.Sources;
    
    
    const Promocion = Promociones.find(promocion =>
    {
        if(promocion.utm_source === utm_source && promocion.utm_tracking === utm_tracking)
            return promocion;
    });

    if(!Promocion) return;

    const comentario = Promocion;
    const discount = Number(Promocion.discount);

    await store.getters["Misc/getResources"];
    store.commit("Misc/setPromocion", {discount,title:Promocion.title});
    store.commit("Empresas/setCupon",Promocion);
} 

export const provincias = ['Buenos Aires','CABA','Córdoba','Santa Fe','Mendoza','Tucumán','Entre Ríos','Neuquén',
        'Río Negro','Chubut','Salta','Misiones','Corrientes','San Juan','San Luis','La Pampa',
        'La Rioja','Catamarca','Formosa','Chaco','Santiago del Estero','Santa Cruz','Jujuy','Tierra del Fuego']